import React from 'react'
import Joyride from 'react-joyride';
import { useTranslation } from 'react-i18next';
import { redirectTo } from 'src/utils/Http';
import { optionStyles, locale } from '../customize';

export default function EditClientStep({ cookie, isExpand, setIsExpand, setTutorialStep1 }) {
  const { t } = useTranslation()
  const { run, stepIndex, tourCompleted, type } = cookie

  const checkLocationPath = (target) => {
    return window.location.pathname == '/clients/edit' ? target : '.NotFoundClass'
  }

  const step = [
    {
      target: '#client_info.Setup__item--1ANJP',
      content: t('features.GuideTour.ClientInfoStep.EditClientStep.0'),
      disableBeacon: true,
      placement: 'auto',
    },
    {
      target: checkLocationPath('section:nth-child(3)'),
      content: t('features.GuideTour.ClientInfoStep.EditClientStep.1'),
      placement: 'auto',
    },
    {
      target: checkLocationPath('section:nth-child(7)'),
      content: <React.Fragment>
        {t('features.GuideTour.ClientInfoStep.EditClientStep.2').split(';').map((text, index) =>
          <p key={index} style={{ textAlign: 'left' }}>{text}</p>
        )}
      </React.Fragment>,
      placement: 'auto',
    },
    {
      target: checkLocationPath('section:nth-child(7) > div.Form__boxMain--FpqUy > div > div > div:nth-child(1) > section'),
      content: <React.Fragment>
        {t('features.GuideTour.ClientInfoStep.EditClientStep.3').split(';').map((text, index) =>
          <p key={index} style={{ textAlign: 'left' }}>{text}</p>
        )}
      </React.Fragment>,
      placement: 'auto',
    },
    {
      target: checkLocationPath(".u-ta-c.u-mt20 div"),
      content: t('features.GuideTour.ClientInfoStep.EditClientStep.4'),
      placement: 'auto',
    },
  ];

  const setStepIndex = (newIndex) => {
    setTutorialStep1({ run, stepIndex: newIndex, tourCompleted, type })
  }

  const setTourCompleted = () => {
    setTutorialStep1({ run: false, stepIndex: 0, tourCompleted: true, type: 'next' })
  }

  const handleCallback = data => {
    const { action, index, lifecycle, type } = data;
    const newIndex = index + (action === 'prev' ? -1 : 1);

    if (action === 'skip') {
      setTourCompleted()
    }
    else if (type === 'step:after' && index === 0) {
      setStepIndex(newIndex)
      redirectTo('/clients/edit')
    }
    else if (type === 'step:after' && index === 1) {
      setStepIndex(newIndex)
      action === 'prev' && redirectTo('/dashboards')
    }
    else if (type === 'step:after' && index === 2) {
      if (!isExpand) {
        const wrapper = document.getElementsByTagName("section")[2].children[1].children[0].children[0].children[0].children[0]
        if (wrapper) wrapper.click()
        setTimeout(() => setStepIndex(newIndex), 300)
        setIsExpand(true)
      }
      else {
        setStepIndex(newIndex)
      }
    }
    else if (type === 'step:after' && index === 3) {
      setStepIndex(newIndex)
    }
    else if (type === 'step:after' && index === 4) {
      if (action == 'prev') {
        if (!isExpand) {
          const wrapper = document.getElementsByTagName("section")[2].children[1].children[0].children[0].children[0].children[0]
          if (wrapper) wrapper.click()
          setTimeout(() => setStepIndex(newIndex), 300)
          setIsExpand(true)
        }
        else {
          setStepIndex(newIndex)
        }
      } 
        }
  };

  return (
<Joyride
      steps={step}
      run={run}
      stepIndex={stepIndex}
      callback={handleCallback}
      styles={optionStyles}
      locale={locale(t)}
      continuous
      scrollToFirstStep
      hideCloseButton
      showProgress
      showSkipButton
      disableOverlayClose
    />
  )
}

